import Vue from 'vue';
import { deepAssign } from '../utils/json/deep-assign';
import defaultMessages from './lang/zh-CN';
import { get } from '../utils';
var proto = Vue.prototype;
var defineReactive = Vue.util.defineReactive;
defineReactive(proto, '$bytedLanguage', 'zh-CN');
defineReactive(proto, '$bytedMessages', {
  'zh-CN': defaultMessages
});
export default {
  messages: function messages() {
    return proto.$bytedMessages[proto.$bytedLanguage];
  },
  use: function use(lang, messages) {
    var _this$add;

    proto.$bytedLanguage = lang;
    this.add((_this$add = {}, _this$add[lang] = messages, _this$add));
  },
  add: function add(messages) {
    if (messages === void 0) {
      messages = {};
    }

    deepAssign(proto.$bytedMessages, messages);
  },
  _i18nTranslate: null,
  i18n: function i18n(translateFunc) {
    if (translateFunc) {
      this._i18nTranslate = translateFunc;
    }
  },
  _t: function _t(key, value) {
    if (value === void 0) {
      value = '';
    }

    return get(this.messages(), key) || value;
  },
  t: function t(key, value) {
    if (value === void 0) {
      value = '';
    }

    if (this._i18nTranslate) {
      return this._i18nTranslate(key, value);
    }

    return this._t(key, value);
  }
};